//console.log('Main loaded');

// Styles
import "@sass/main.scss";

// Vendor
import "@js/vendor.bootstrap";

// Modules
import "@js/modules.bootstrap";


$(document).ready(function () {
	if (!$("#popup_window").length) { // init if not in dialog view
		iframe_adaptability();
		select2();
		fancybox();
	}
});

function iframe_adaptability() {
	var $container = $(".content_template");
	var $iframes = $("iframe");

	$container.find($iframes).each(function () {
		$(this).wrap("<div class='iframe_wrapper'></div>");
	});
}

function select2() {
	$("select:not(.noselect2)").select2({
		"minimumResultsForSearch": -1
	});
	
	$(".lang select:not(.noselect2)").select2({
		"minimumResultsForSearch": -1,
		dropdownCssClass: "select2-dropdown--lang"
	});

	$("select.select2_with_dynamic_placeholder").select2({
		"minimumResultsForSearch": -1,
		placeholder: function () {
			$(this).data('placeholder');
		}
	});
}

function fancybox() {
	// FB3 docs: https://fancyapps.com/fancybox/3/docs
	//  Translations inside libs/localization/

	// Image preview
	$("a[data-fancybox]").fancybox({
		infobar: false,
		loop: false,
		arrows: false,
		buttons: [
			"close"
		],
		btnTpl: {
		    zoom: false
		}
	});
}

class jsDataProvider
{
	constructor(){
		this.data = {};
		this.is_data = false;
		var varName = 'jsData';
		if(arguments[0] && arguments[0] !== ''){
			varName = arguments[0];
		}
		if(typeof(window[varName]) !== 'undefined'){
			this.data = window[varName];
			this.is_data = true;
		}
	}
	
	isData(){
		return this.is_data;
	}
	
	getAllData(){
		return this.data;
	}
	
	get(key){
		if(typeof(this.data[key]) !== 'undefined'){
			return this.data[key];
		}
		if(arguments.length > 1){
			return arguments[1];
		}
		return null;
	}
}

const jsDataService = new jsDataProvider();

class examDataStorage
{
	constructor(){
		this.init();
	}
	
	init(){
		this.storage = {
			initial: 'test'
		};
	}
	
	set(key, value){
		this.storage[key] = value;
	}
	
	get(key){
		if(typeof(this.storage[key]) !== 'undefined'){
			return this.storage[key];
		}
		if(arguments[1]){
			return arguments[1];
		}
		return null;
	}
	
	getStorage(){
		return this.storage;
	}
	
	all(){
		return this.getStorage();
	}
}

const examDataService = new examDataStorage();

class trStrings
{
	constructor(){
		this.data = jsDataService.get('tr', {});
	}
	
	get(key){
		if(typeof(this.data[key]) !== 'undefined'){
			return this.data[key];
		}
		if(arguments[1]){
			return arguments[1];
		}
		return '*'+key+'*';
	}
}

const translations = new trStrings();

function leaveAction(){
	this.action;
	var self = this;
	this.call = function(event){
		if(!angular.isUndefined(self.action)){
			return self.action(event);
		}
	};
}

var la = new leaveAction();

window.addEventListener('beforeunload', la.call);

var EwSiteApp = angular.module('EwSiteApp', ['ngSanitize', 'ngRoute', 'ngDialog']);

EwSiteApp.config(["$httpProvider", function($httpProvider) {
	if(typeof(secure_xsrf_name) != 'undefined'){
		$httpProvider.defaults.xsrfCookieName = secure_xsrf_name;
		$httpProvider.defaults.xsrfHeaderName = 'X-' + secure_xsrf_name;
	}
}]);

EwSiteApp.config(['$provide', function ($provide) {
		$provide.decorator('$browser', ['$delegate', function ($delegate) {
				$delegate.onUrlChange = function () {};
				$delegate.url = function () {
					return "";
				};
				return $delegate;
			}
		]);
	}
]);
	
EwSiteApp.filter('u2date', ['$filter', function ($filter) {
	return function (udate) {
		var format = 'yyyy-MM-dd';
		if (arguments[1]) {
			format = arguments[1];
		}
		return $filter('date')(udate * 1000, format);
	};
}]);

EwSiteApp.controller('LangChanger', ['$scope', function($scope){
	$scope.langs = jsDataService.get('langs', {});
	$scope.lang = current_lang;
	$scope.$watch("lang", function(newVal, oldVal){
		if(newVal != oldVal && typeof($scope.langs[newVal]) !== 'undefined'){
			location.href = $scope.langs[newVal].url;
		}
	});
}]);

EwSiteApp.service('examData', [function(){
	return examDataService;
}]);

EwSiteApp.service('trs', [function(){
	return translations;
}]);

EwSiteApp.service('leavePage', function(){
	return la;
});

EwSiteApp.config(['$routeProvider', function($routeProvider){
	$routeProvider
	.when('/student', {
		templateUrl: 'takeexam/userinfo.html',
		controller: 'UserInfoCtrl'
	})
	.when('/rules', {
		templateUrl: 'takeexam/rules.html',
		controller: 'RulesCtrl'
	})
	.when('/prepare', {
		templateUrl: 'takeexam/prepare.html',
		controller: 'PrepareCtrl'
	})
	.when('/questions', {
		templateUrl: 'takeexam/questions.html',
		controller: 'QuestionsCtrl'
	})
	.when('/results', {
		templateUrl: 'takeexam/results.html',
		controller: 'ResultsCtrl'
	})
	.when('/review', {
		templateUrl: 'takeexam/review.html',
		controller: 'ReviewResultsCtrl'
	})
	.when('/wait', {
		templateUrl: 'takeexam/waitting.html'
	})
	.otherwise({
		templateUrl: 'takeexam/authorize.html',
		controller: 'AuthorizeCtrl'
	});
}]);

EwSiteApp.run(['$rootScope', '$location', '$window', '$timeout', 'examData', 'leavePage', function($rootScope, $location, $window, $timeout, examData, leavePage){
	$rootScope.allowLeave = true;
	
	$rootScope.validateRoute = function(route){
//		console.log(route);
		switch(route){
			case 'student':
				if(!isAuthotrized()){
					$rootScope.go('');
				}
				break;
			case 'rules':
				if(!examData.get('userinfo', false)){
					$rootScope.go('student');
				}
				if(examData.get('completed', false)){
					$rootScope.go('results');
				}
				break;
			case 'prepare':
				if(!examData.get('rules', false)){
					$rootScope.go('rules');
				}
				if(examData.get('completed', false)){
					$rootScope.go('results');
				}
				break;
			case 'questions':
				if(!examData.get('isquestions', false)){
					$rootScope.go('prepare');
				}
				if(examData.get('completed', false)){
					$rootScope.go('results');
				}
				break;
			case 'results':
				if(!examData.get('completed', false)){
					$rootScope.go('questions');
				}
				break;
			case 'review':
				if(!examData.get('allow_review', false)){
					$rootScope.go('results');
				}
				break;
		}
	};
	
	$rootScope.go = function(path){
		$location.path('/'+path);
	};
	
	function isAuthotrized(){
		return (examData.get('auth', false));
	}
	
	$rootScope.closeExam = function(){
		examData.init();
		$rootScope.go('wait');
		$rootScope.lockReload(false);
		$timeout(function(){
			$window.location.reload();
		}, 30);
	};
	
	leavePage.action = function(event){
		if(!$rootScope.allowLeave){
			var confirmationMessage = "In progress ... }O{";
			event.returnValue = confirmationMessage;
			return confirmationMessage;
		}
	};
	
	$rootScope.lockReload = function(state){
		$rootScope.allowLeave = !state;
	};
	
}]);

/**
 * Alert usage
 * popup.alert('MESSAGE').then(function(){
 *	//do something
 * });
 * 
 * Confirm usage
 * popup.confirm('Ar to norejei?').then(function(value){
 *	// do something
 * });
 */

EwSiteApp.service('popup', ['ngDialog', function(ngDialog){
	var data = {
		message: ''
	};
	return {
		alert: showAlert,
		confirm: showConfirm
	};
	
	function showAlert(message){
		angular.extend(data, {message: message});
		return ngDialog.open({ 
			template: 'alert.html', 
			className: 'ngdialog-theme-default',
			closeByDocument: false,
			closeByEscape: false,
			data: data
		}).closePromise;
	}
	
	function showConfirm(message){
		angular.extend(data, {message: message});
		return ngDialog.openConfirm({ 
			template: 'confirm.html', 
			className: 'ngdialog-theme-default',
			closeByDocument: false,
			closeByEscape: false,
			data: data
		}).then(function(value){
			return value;
		}, function(value){
			return value;
		});
	}
}]);

EwSiteApp.controller('AuthorizeCtrl', ['$scope', '$http', '$timeout', 'examData', 'popup', 'trs', function ($scope, $http, $timeout, examData, popup, trs) {
	$scope.idcode = '';
	var sessionEnd = jsDataService.get('sessionInterval', 300);
	var timmer;
	
	function refreshSession(){
		var interval = sessionEnd*1000;
		timmer = $timeout(function(){
			$http({
				method: 'GET',
				url: jsDataService.get('sessionRefreshUrl', null)
			}).then(function(){
				refreshSession();
			});
		}, interval);
	}
	refreshSession();
	
	$scope.$on('$destroy', function() {
		$timeout.cancel(timmer);
	});
	
	$scope.authSubmit = function(){
		const authUrl = jsDataService.get('authUrl', null);
		
		$http({
			method: 'POST',
			url: authUrl,
			data: {
				idcode: $scope.idcode
			}
		}).then(function(response){
			if(response.data.success){
				examData.set('auth', true);
				examData.set('student', response.data.student);
				examData.set('exam', response.data.exam);
				$scope.lockReload(true);
				if(response.data.exam.continue){
					examData.set('userinfo', true);
					if(response.data.exam.rules_accepted > 0){
						examData.set('rules', true);
						$scope.go('prepare');
					}
					else{
						$scope.go('rules');
					}
				}
				else{
					$scope.go('student');
				}
			}
			else{
				if(response.data.message){
					popup.alert(response.data.message);
				}
				else{
					popup.alert(trs.get('unknown_error'));
				}
			}
		}, function(response){
			console.log(response);
			popup.alert(trs.get('network_error'));
		});
	};
}]);

EwSiteApp.controller('UserInfoCtrl', ['$scope', 'examData', function ($scope, examData) {
	$scope.validateRoute('student');
	$scope.title = examData.get('exam', {title:''}).title;
	$scope.student = examData.get('student');
	
	$scope.submit = function(){
		examData.set('userinfo', true);
		$scope.go('rules');
	};
}]);

EwSiteApp.controller('RulesCtrl', ['$scope', 'examData', function ($scope, examData) {
	$scope.validateRoute('rules');
	$scope.rules = examData.get('exam', {rules:''}).rules;
	$scope.submit = function(){
		examData.set('rules', true);
		$scope.go('prepare');
	};
	
}]);

EwSiteApp.controller('PrepareCtrl', ['$scope', '$http', '$timeout', 'examData', 'popup', 'trs', function ($scope, $http, $timeout, examData, popup, trs) {
	$scope.validateRoute('prepare');
	$scope.ready = false;
	$scope.loading = false;
	$scope.newExam = !examData.get('exam', {'continue': false}).continue;
	const dataUrl = examData.get('exam', {data_url:''}).data_url;
	
	if(dataUrl !== ''){
		$scope.loading = true;
		$http({
			method: 'GET',
			url: dataUrl
		}).then(function(response){
			if(response.data.success){
				examData.set('questions', response.data.questions);
				examData.set('isquestions', true);
				$scope.ready = true;
			}
			else{
				if(response.data.message){
					popup.alert(response.data.message);
				}
				else{
					popup.alert(trs.get('unknown_error'));
				}
			}
		}, function(response){
			popup.alert(trs.get('network_error')).then(function(){
				$scope.closeExam();
			});
		}).then(function(){
			$scope.loading = false;
		});
	}
	
	const startUrl = examData.get('exam', {start_url:''}).start_url;
	var counter = 0;
	const retryInterval = 5000;
	const requestTimeout = 10000;
		
	function storeStart(){
		$http({
			method: 'GET',
			url: startUrl,
			timeout: requestTimeout
		}).then(function(response){
			if(!response.data.success){
				popup.alert(response.data.message).then(function(){
					$scope.closeExam();
				});
			}
		}, function(){
			counter++;
			if(counter < 3){
				$timeout(function(){
					storeStart();
				}, retryInterval);
			}
			else{
				popup.alert(trs.get('network_error')).then(function(){
					$scope.closeExam();
				});
			}
		});
	}
	
	$scope.startExam = function(){
		if(!$scope.ready){
			return false;
		}
		storeStart();
		$scope.go('questions');
	};
	
}]);

EwSiteApp.controller('QuestionsCtrl', ['$scope', '$filter', '$http', '$timeout', 'examData', 'popup', 'trs', function ($scope, $filter, $http, $timeout, examData, popup, trs) {
	$scope.validateRoute('questions');
	$scope.exam = examData.get('exam', {});
	$scope.pagination = [];
	$scope.currentPage = {idx: -1};
	$scope.timeFlow = true;
	$scope.submitted = false;
	$scope.question = {
		answers: [],
		left: 0
	};
	$scope.exam.use_time_count = ($scope.exam.use_time_count == 1);
	$scope.exam.allow_skip = ($scope.exam.allow_skip == 1);
	$scope.exam.allow_change = ($scope.exam.allow_change == 1);
	$scope.exam.use_sequence = ($scope.exam.use_sequence == 1);
	$scope.exam.multi_options = ($scope.exam.multi_options == 1);
	
	var questions = examData.get('questions', []);
	var map = {};
	
	function fixAChecks(question){
		if(typeof(question.answers) !== 'undefined'){
			for(var i = 0; i < question.answers.length; i++){
				question.answers[i].checked = (true === question.answers[i].checked || question.answers[i].checked == 1);
			}
		}
		question.skipped = (question.skipped == 1);
	}
	
	function setQuestionTime(question){
		if(typeof(question.time_limit) !== 'undefined' && !isNaN(question.time_limit) && typeof(question.time_used_in_s) !== 'undefined' && !isNaN(question.time_used_in_s)){
			question.left = Math.round((parseInt(question.time_limit) * 60) - parseInt(question.time_used_in_s));
		}
		else{
			question.left = 0;
		}
		question.timeAlert = (question.left < 1);
	}
	
	function initQuestions(){
		for(var i = 0; i < questions.length; i++){
			var k = 'q'+questions[i].id;
			fixAChecks(questions[i]);
			setQuestionTime(questions[i]);
			map[k] = questions[i];
			var answered = ($filter('filter')(questions[i].answers, {checked: true}, true).length > 0);
			var viewed = false;
			var done = false;
			if(answered){
				viewed = true;
				done = true;
			}
			if(questions[i].time_used_in_s > 0){
				viewed = true;
			}
			if($scope.exam.use_time_count && questions[i].left < 1){
				done = true;
			}
//			if(!$scope.exam.allow_change && questions[i].skipped){
//				viewed = true;
//				done = true;
//			}
			$scope.pagination.push({
				current: false,		//einamasis
				viewed: viewed,		// buvo perziuretas
				answered: answered,	// turi pazymeta atsakyma
				done: done,			// baigtas: answered arba pasibaiges laikas
				title: (i+1),
				key: k,
				idx: i
			});
		}
	}
	
	function setPage(){
		var idx = 0;
		if(arguments[0] && !isNaN(arguments[0])){
			idx = parseInt(arguments[0]);
		}
		
		if($scope.currentPage.idx !== idx && typeof($scope.pagination[idx]) !== 'undefined' && typeof(map[$scope.pagination[idx].key]) !== 'undefined'){
			
			var curr = $filter('filter')($scope.pagination, {current: true});
			if(curr.length > 0){
				curr[0].current = false;
				curr[0].viewed = true;
				curr[0].answered = ($filter('filter')($scope.question.answers, {checked: true}, true).length > 0);
			}
			
			$scope.currentPage = $scope.pagination[idx];
			$scope.currentPage.current = true;
			$scope.question = map[$scope.currentPage.key];
			$scope.timeFlow = true;
		}
	}
	initQuestions();
//	setPage();
	var statusTimmer;
	const statusInterval = 8000;
	const questionUrl = $scope.exam.question_url;
	const statusUrl = $scope.exam.status_url;
	const retryInterval = 5000;
	const requestTimeout = 10000;
	var counter = 0;
	var blockPopupOpen = false;
	
	function checkStatus(){
		if(statusUrl && statusUrl !== ''){
			statusTimmer = $timeout(function(){
				$http({
					method: 'GET',
					url: statusUrl
				}).then(function(response){
					if(typeof(response.data.action) !== 'undefined'){
						if(response.data.action == 'continue'){
							checkStatus();
						}
						else{
							blockPopupOpen = true;
							$scope.timeFlow = false;
							popup.alert(response.data.message).then(function(){
								blockPopupOpen = false;
								$scope.timeFlow = true;
								// jei ne continue turetu buti stop
								$scope.closeExam();
							});
						}
					}
				});
			}, statusInterval);
		}
	}
	checkStatus();
	
	$scope.$on('$destroy', function() {
		cancelStatus();
	});
	
	function cancelStatus(){
		$timeout.cancel(statusTimmer);
	}
	
	function storeQuestion(questionData){
		if(questionUrl == ''){
			$scope.timeFlow = false;
			popup.alert(trs.get('cant_save_question')).then(function(){
				$scope.timeFlow = true;
				$scope.closeExam();
			});
		}
		else{
			$http({
				method: 'POST',
				url: questionUrl,
				timeout: requestTimeout,
				data: questionData
			}).then(function(response){
				if(!response.data.success){
					if(!blockPopupOpen){
						blockPopupOpen = true;
						$scope.timeFlow = false;
						var m = trs.get('unknown_error');
						if(typeof(response.data.message) !== 'undefined'){
							m  = response.data.message;
						}
						popup.alert(m).then(function(){
							blockPopupOpen = false;
							$scope.timeFlow = true;
							$scope.closeExam();
						});
					}
				}
			}, function(){
				counter++;
				if(counter < 3){
					if(!blockPopupOpen){
						$timeout(function(){
							storeQuestion(questionData);
						}, retryInterval);
					}
				}
				else{
					if(!blockPopupOpen){
						blockPopupOpen = true;
						$scope.timeFlow = false;
						popup.alert(trs.get('network_error')).then(function(){
							blockPopupOpen = false;
							$scope.timeFlow = true;
							$scope.closeExam();
						});
					}
				}
			});
		}
	}
	
	if($scope.exam.use_time_count){
		$scope.$watch(function(){
			return $scope.question.left;
		}, function(value){
			if(typeof($scope.question.id) !== 'undefined' && $scope.question.id > 0 && value < 1){
				$scope.timeFlow = false;
				if(!$scope.question.timeAlert){
					popup.alert(trs.get('question_time_expired')).then(function(){
//						$scope.currentPage.done = true;
//						$scope.currentPage.viewed = true;
						$scope.question.timeAlert = true;
						$scope.goNext(true);
						$scope.timeFlow = true;
					});
				}
			}
		});
	}
	else{
		$scope.$watch(function(){
			return $scope.exam.left;
		}, function(value){
			if(typeof($scope.question.id) !== 'undefined' && $scope.question.id > 0 && value < 1){
				$scope.timeFlow = false;
				popup.alert(trs.get('exam_time_expired')).then(function(){
					// complete exam
					$scope.submit();
				});
			}
		});
	}
	
	$scope.navGoTo = function(page){
		if($scope.navBtnActive(page)){
			if(storeCurrentPage()){
				$scope.goTo(page);
			}
		}
	};
	
	$scope.goTo = function(page){
		setPage(page.idx);
	};
	
	$scope.checkAnswer = function(answer){
		if(!$scope.exam.multi_options){
			var a = $filter('filter')($scope.question.answers, {id: '!'+answer.id, checked: true}, true);
			if(a.length > 0){
				for(var i = 0; i < a.length; i++){
					a[i].checked = false;
				}
			}
		}
	};
	
	$scope.hasUnaswered = function(){
		return ($filter('filter')($scope.pagination, {done: false}, true).length > 0);
	};
	
	$scope.isLast = function(){
		return (($scope.pagination.length-1) == $scope.currentPage.idx);
	};
	
	$scope.questionDisabled = function(){
		if(!$scope.exam.allow_change && $scope.currentPage.done){
			$scope.timeFlow = false;
			return true;
		}
		if(($scope.exam.use_time_count && $scope.question.left < 1) || (!$scope.exam.use_time_count && $scope.exam.left < 1)){
			$scope.timeFlow = false;
			return true;
		}
		return false;
	};
	
	$scope.qbtnDisabled = function(){
		if(!$scope.exam.allow_skip && $filter('filter')($scope.question.answers, {checked: true}, true).length < 1 && (!$scope.exam.use_time_count || $scope.question.left > 0)){
			return true;
		}
		if(!$scope.exam.allow_change && $filter('filter')($scope.pagination, {done: false}, true).length < 1){
			return true;
		}
		if($scope.exam.use_time_count && $filter('filter')(questions, function(value){
				return (value.left > 0);
			}, true).length < 1){
			return true;
		}
		return false;
	};
	
	$scope.navBtnActive = function(page){
		if(!$scope.exam.use_sequence){
			return true;
		}
		if((page.idx == ($scope.currentPage.idx+1) || ($scope.isLast() && page.idx == 0)) && !$scope.qbtnDisabled()){
			var unanswered = $filter('filter')($scope.pagination, {done: false}, true);
			if(unanswered.length > 1){
				return true;
			}
			if(unanswered.length > 0 && unanswered[0].idx != $scope.currentPage.idx){
				return true;
			}
			else if($filter('filter')($scope.question.answers, {checked: true}, true).length > 0){
				return true;
			}
		}
		return false;
	};
	
	$scope.saveCurrent = function(){
		if(!$scope.questionDisabled() || arguments[0]){
			var q = angular.copy($scope.question);
			q.ticket_time_left = $scope.exam.left;
			storeQuestion(q);
		}
	};
	
	$scope.goNext = function(){
		if(storeCurrentPage(arguments[0])){
			callNavigationAction();
		}
	};
	
	$scope.showSubmit = function(){
		if($scope.submitted){
			return false;
		}
		if($filter('filter')($scope.pagination, {done: false}, true).length < 1){
			return true;
		}
		return false;
	};
	
	$scope.submit = function(){
		$scope.go('wait');
		const completeUrl = examData.get('exam', {complete_url:''}).complete_url;
		$scope.timeFlow = false;
		$scope.submitted = true;
		if(completeUrl === ''){
			popup.alert(trs.get('cant_complete_exam')).then(function(){
				$scope.closeExam();
			});
		}
		var rq = $http({
			method: 'POST',
			url: completeUrl,
			timeout: requestTimeout,
			data: {
				exam: $scope.exam,
				questions: map
			}
		});
		rq.then(function(response){
			if(response.data.success){
				examData.set('completed', true);
				if(typeof(response.data.results) !== 'undefined'){
					examData.set('allow_review', response.data.results.allow_review);
					examData.set('passed', response.data.results.passed);
					examData.set('result', response.data.results.title);
					examData.set('result_questions', response.data.results.questions);
				}
				$scope.go('results');
			}
			else{
				var m = trs.get('retry_on_error');
				if(typeof(response.data.message) !== 'undefined'){
					m  = response.data.message;
				}
				popup.confirm(m).then(function(val){
					if(val == 1){
						$scope.submit();
					}
					else{
						$scope.closeExam();
					}
				});
			}
		}, function(){
			popup.alert(trs.get('network_error')).then(function(){
				$scope.closeExam();
			});
		});
		rq.then(function(){
			cancelStatus();
		});
	};
	
	function storeCurrentPage(){
		var noChecked = ($filter('filter')($scope.question.answers, {checked: true}, true).length < 1);
		if(((!noChecked || ($scope.exam.use_time_count && $scope.question.left < 1)) || $scope.exam.allow_skip) && ($scope.exam.use_time_count || $scope.exam.left > 0)){
			if(noChecked){
				$scope.question.skipped = true;
				$scope.currentPage.done = false;
				$scope.currentPage.answered = false;
			}
			$scope.saveCurrent(arguments[0]);
			$scope.currentPage.viewed = true;
			if(!noChecked){
				$scope.currentPage.done = true;
				$scope.currentPage.answered = true;
			}
			else if($scope.exam.use_time_count && $scope.question.left < 1){
				$scope.currentPage.done = true;
			}
			return true;
		}
		return false;
	}
	
	function callNavigationAction(){
		if($scope.exam.allow_change){
			navigationAction();
		}
		else if(!$scope.isLast()){
			if($scope.hasUnaswered() || $scope.exam.allow_skip){
				navigationAction();
			}
		}
		else if($scope.exam.allow_skip && $scope.hasUnaswered()){
			navigationAction();
		}
	}
	
	function navigationAction(){
		if($scope.hasUnaswered()){
			var b = $filter('filter')($scope.pagination, function(value){
				return (!value.done && value.idx > $scope.currentPage.idx);
			}, true);
			if(b.length > 0){
				$scope.goTo(b[0]);
			}
			else{
				$scope.goTo($filter('filter')($scope.pagination, {done: false}, true)[0]);
			}
		}
		else{
			if($scope.currentPage.idx > -1){
				var b = $filter('filter')($scope.pagination, function(value){
					return (value.idx > $scope.currentPage.idx);
				}, true);
				if(b.length > 0){
					$scope.goTo(b[0]);
				}
				else{
					$scope.goTo($scope.pagination[0]);
				}
			}
			else{
				$scope.goTo($scope.pagination[0]);
			}
		}
	}
	
	navigationAction();
	
	// perziuros tikslais
	$scope.getNavBtnStyle = function(page){
		var loc = (!$scope.navBtnActive(page)) ? ' loc' : '';
//		var s = {};
		if(page.current){
			return 'current' + loc;
		}
		if(page.answered){
			return 'pass' + loc;
		}
		if(page.viewed){
			return 'visited' + loc;
		}
		return '' + loc;
//		return s;
	};
	
}]);

EwSiteApp.controller('ResultsCtrl', ['$scope', 'examData', 'popup', function ($scope, examData, popup) {
	$scope.validateRoute('results');
	$scope.passed = examData.get('passed', false);
	$scope.result = examData.get('result', '');
	$scope.reviewResults = examData.get('allow_review', false);
	$scope.close = function(){
		$scope.closeExam();
	};
	
	$scope.review = function(){
		if($scope.reviewResults){
			$scope.go('review');
		}
	};
	
}]);

EwSiteApp.controller('ReviewResultsCtrl', ['$scope', '$filter', 'examData', function ($scope, $filter, examData) {
	$scope.validateRoute('review');
	
	$scope.pagination = [];
	$scope.currentPage = {idx: -1};
	$scope.question = {
		correct: false
	};
	
	var map = {};
	
	function initQuestions(){
		var questions = examData.get('result_questions', []);
		for(var i = 0; i < questions.length; i++){
			var k = 'q'+questions[i].id;
			questions[i].correct = (questions[i].passed==1);
			map[k] = questions[i];
			$scope.pagination.push({
				done: false,
				title: (i+1),
				key: k,
				current: false,
				correct: map[k].correct,
				idx: i
			});
		}
	}
	
	function setPage(){
		var idx = 0;
		if(arguments[0] && !isNaN(arguments[0])){
			idx = parseInt(arguments[0]);
		}
		var curr = $filter('filter')($scope.pagination, {current: true});
		if(curr.length > 0){
			curr[0].current = false;
		}
		if($scope.currentPage.idx !== idx && typeof($scope.pagination[idx]) !== 'undefined' && typeof(map[$scope.pagination[idx].key]) !== 'undefined'){
			$scope.currentPage = $scope.pagination[idx];
			$scope.currentPage.current = true;
			$scope.question = map[$scope.currentPage.key];
		}
	}
	initQuestions();
	setPage();
	
	$scope.goTo = function(page){
		setPage(page.idx);
	};
	
	$scope.goNext = function(){
		if(($scope.pagination.length-1) == $scope.currentPage.idx){
			$scope.goTo($scope.pagination[0]);
		}
		else if(typeof($scope.pagination[$scope.currentPage.idx+1]) !== 'undefined'){
			$scope.goTo($scope.pagination[$scope.currentPage.idx+1]);
		}	
	};
	
	$scope.close = function(){
		$scope.closeExam();
	};
	
	$scope.results = function(){
		$scope.go('results');
	};
	
}]);

EwSiteApp.directive('countDown', ['$interval', function($interval){
	return {
		restrict: 'E',
		scope: {
			model: '=ngModel',
			controll: '=?controll'
		},
		link: function(scope){
			scope.minf = '--';
			scope.sf = '--';
			function format(){
				var min = Math.floor(scope.model / 60);
				if(min < 10){
					scope.minf = '0'+min;
				}
				else{
					scope.minf = new String(min);
				}
				var s = Math.round(scope.model - (min * 60));
				if(s < 10){
					scope.sf = '0'+s;
				}
				else{
					scope.sf = new String(s);
				}
			}
			format();
			scope.$watch(function(){
				return scope.model;
			}, function(){
				format();
			});
			
			function tm(){
				$interval(function(){
					if(scope.model>0 && scope.controll){
						scope.model--;
					}
				}, 1000);
			}
			tm();
			
		},
		template: '{{minf}}:{{sf}}'
	};
}]);


